import classNames from 'classnames';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AccountIcon from '@material-ui/icons/AccountCircle';
import AndroidIcon from '@material-ui/icons/Android';
import GroupIcon from '@material-ui/icons/Group';
import HomeIcon from '@material-ui/icons/Home';
import IosIcon from '@material-ui/icons/PhoneIphone';
import SettingsIcon from '@material-ui/icons/Settings';
import SignInOutIcon from '@material-ui/icons/SwapHoriz';

import { IState } from '../types';
import { isLoggedIn } from '../utils/authentication';
import { withDefaultStyles } from '../utils/material-ui/hoc';

class AppDrawer extends React.Component<IState | any, IState> {
  public render() {
    const { classes, app } = this.props;
    return (
      <div style={this.props.style}>
        <Drawer
          variant="persistent"
          classes={{
            paper: classNames(classes.drawerPaper, !app.drawerOpen && classes.drawerPaperClose),
          }}
          anchor="left"
          open={app.drawerOpen}
        >
          <Divider />
          <List>
            <ListItem button={true} key='android' selected={this.isSelected('android')}>
              <ListItemIcon><AndroidIcon /></ListItemIcon>
              <ListItemText>Android SDK</ListItemText>
            </ListItem>
            <ListItem button={true} key='ios' selected={this.isSelected('ios')}>
              <ListItemIcon><IosIcon /></ListItemIcon>
              <ListItemText>iOS SDK</ListItemText>
            </ListItem>
          </List>
          <Divider />
          <List>
            <ListItem button={true} key='main' selected={this.isSelected('main')} onClick={this.props.onMain}>
              <ListItemIcon><HomeIcon /></ListItemIcon>
              <ListItemText>Main</ListItemText>
            </ListItem>
            <ListItem button={true} key='console' selected={this.isSelected('console')} onClick={this.props.onConsole}>
              <ListItemIcon><SettingsIcon /></ListItemIcon>
              <ListItemText>Console</ListItemText>
            </ListItem>
            <ListItem button={true} key='tenants' selected={this.isSelected('tenants')} onClick={this.props.onTenants}>
              <ListItemIcon><GroupIcon /></ListItemIcon>
              <ListItemText>Tenants</ListItemText>
            </ListItem>
          </List>
          <Divider />
          {this.props.children}
          <div style={{ height: '100%' }} />
          <Divider />
          {isLoggedIn(this.props.authentication) ? this.signOutItem() : this.signInItem()}
        </Drawer>
      </div>
    );
  }

  private isSelected = (key: string) => this.props.selectedMenu === key;

  private signInItem = () =>
    <List>
      <ListItem button={true} key='Signin' onClick={this.props.onSignin}>
        <ListItemIcon><SignInOutIcon /></ListItemIcon>
        <ListItemText>Sign in</ListItemText>
      </ListItem>
    </List>
  private signOutItem = () =>
    <List>
      <ListItem key='Profile'>
        <ListItemIcon><AccountIcon /></ListItemIcon>
        <ListItemText>{this.props.authentication.session.user.firstName + ' ' + this.props.authentication.session.user.lastName}</ListItemText>
      </ListItem>
      <List style={{ paddingLeft: '10px' }}>
        <ListItem button={true} key='Signout' onClick={this.props.onSignout}>
          <ListItemIcon><SignInOutIcon /></ListItemIcon>
          <ListItemText>Sign out</ListItemText>
        </ListItem>
      </List>
    </List>
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}


export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(AppDrawer)));



// WEBPACK FOOTER //
// ./src/components/drawer.tsx